/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type SubscriptionsTableV2SubscriptionFragment = { __typename: 'WaveSubscription', id: string, name: string, userGivenName?: string | null, createdAt: any, validUntil: any, status: Types.WaveSubscriptionStatus, productId: string, customers: Array<{ __typename: 'PartialCustomer', name: string }>, usage: { __typename: 'SubscriptionUsage', max?: number | null, current: number } };

export const SubscriptionsTableV2SubscriptionFragmentDoc = gql`
    fragment SubscriptionsTableV2Subscription on WaveSubscription {
  id
  name
  userGivenName
  customers {
    name
  }
  createdAt
  validUntil
  usage {
    max
    current
  }
  status
  productId
}
    `;